"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatusCode = exports.ReversalType = exports.Device = exports.DeviceInputCode = exports.TransactionSetupMethod = exports.TerminalType = exports.TerminalEnvironmentCode = exports.TerminalCapabilityCode = exports.MotoECICode = exports.CVVPresenceCode = exports.CardPresentCode = exports.CardInputCode = exports.CardholderPresentCode = exports.PaymentAccountType = exports.WorldpayReceiptOption = exports.MarketCode = exports.PromptForSignature = exports.TransactionTypes = void 0;
var TransactionTypes;
(function (TransactionTypes) {
    TransactionTypes["SALE"] = "sale";
    TransactionTypes["REFUND"] = "refund";
    TransactionTypes["RETURN"] = "return";
    TransactionTypes["VOID"] = "void";
    TransactionTypes["SYSTEM_REVERSAL"] = "system_reversal";
    TransactionTypes["FULL_REVERSAL"] = "full_reversal";
    TransactionTypes["REIMBURSE"] = "reimburse";
})(TransactionTypes || (exports.TransactionTypes = TransactionTypes = {}));
// We can add threshold option later on
var PromptForSignature;
(function (PromptForSignature) {
    PromptForSignature["ALWAYS"] = "Always";
    PromptForSignature["NEVER"] = "Never";
})(PromptForSignature || (exports.PromptForSignature = PromptForSignature = {}));
/**
 * Express Enumerations: https://developerengine.fisglobal.com/apis/express/express-xml/enumerations
 */
var MarketCode;
(function (MarketCode) {
    MarketCode[MarketCode["DEFAULT"] = 0] = "DEFAULT";
    MarketCode[MarketCode["ECOMMERCE"] = 3] = "ECOMMERCE";
    MarketCode[MarketCode["RETAIL"] = 7] = "RETAIL";
})(MarketCode || (exports.MarketCode = MarketCode = {}));
var WorldpayReceiptOption;
(function (WorldpayReceiptOption) {
    WorldpayReceiptOption["MERCHANT"] = "merchant";
    WorldpayReceiptOption["CUSTOMER"] = "customer";
    WorldpayReceiptOption["REPRINT"] = "reprint";
})(WorldpayReceiptOption || (exports.WorldpayReceiptOption = WorldpayReceiptOption = {}));
var PaymentAccountType;
(function (PaymentAccountType) {
    PaymentAccountType[PaymentAccountType["CREDIT_CARD"] = 0] = "CREDIT_CARD";
    PaymentAccountType[PaymentAccountType["CHEQUING"] = 1] = "CHEQUING";
    PaymentAccountType[PaymentAccountType["SAVINGS"] = 2] = "SAVINGS";
    PaymentAccountType[PaymentAccountType["ACH"] = 3] = "ACH";
    PaymentAccountType[PaymentAccountType["OTHER"] = 4] = "OTHER";
})(PaymentAccountType || (exports.PaymentAccountType = PaymentAccountType = {}));
var CardholderPresentCode;
(function (CardholderPresentCode) {
    CardholderPresentCode[CardholderPresentCode["DEFAULT"] = 0] = "DEFAULT";
    CardholderPresentCode[CardholderPresentCode["UNKNOWN"] = 1] = "UNKNOWN";
    CardholderPresentCode[CardholderPresentCode["PRESENT"] = 2] = "PRESENT";
    CardholderPresentCode[CardholderPresentCode["NOT_PRESENT"] = 3] = "NOT_PRESENT";
    CardholderPresentCode[CardholderPresentCode["MAIL_ORDER"] = 4] = "MAIL_ORDER";
    CardholderPresentCode[CardholderPresentCode["PHONE_ORDER"] = 5] = "PHONE_ORDER";
    CardholderPresentCode[CardholderPresentCode["STANDING_AUTH"] = 6] = "STANDING_AUTH";
    CardholderPresentCode[CardholderPresentCode["ECOMMERCE"] = 7] = "ECOMMERCE";
})(CardholderPresentCode || (exports.CardholderPresentCode = CardholderPresentCode = {}));
var CardInputCode;
(function (CardInputCode) {
    CardInputCode[CardInputCode["DEFAULT"] = 0] = "DEFAULT";
    CardInputCode[CardInputCode["MANUAL_KEYED"] = 4] = "MANUAL_KEYED";
})(CardInputCode || (exports.CardInputCode = CardInputCode = {}));
var CardPresentCode;
(function (CardPresentCode) {
    CardPresentCode[CardPresentCode["DEFAULT"] = 0] = "DEFAULT";
    CardPresentCode[CardPresentCode["UNKNOWN"] = 1] = "UNKNOWN";
    CardPresentCode[CardPresentCode["PRESENT"] = 2] = "PRESENT";
    CardPresentCode[CardPresentCode["NOT_PRESENT"] = 3] = "NOT_PRESENT";
})(CardPresentCode || (exports.CardPresentCode = CardPresentCode = {}));
var CVVPresenceCode;
(function (CVVPresenceCode) {
    CVVPresenceCode[CVVPresenceCode["USE_DEFAULT"] = 0] = "USE_DEFAULT";
    CVVPresenceCode[CVVPresenceCode["NOT_PROVIDED"] = 1] = "NOT_PROVIDED";
    CVVPresenceCode[CVVPresenceCode["PROVIDED"] = 2] = "PROVIDED";
    CVVPresenceCode[CVVPresenceCode["ILLEGIBLE"] = 3] = "ILLEGIBLE";
    CVVPresenceCode[CVVPresenceCode["CUSTOMER_ILLEGIBLE"] = 4] = "CUSTOMER_ILLEGIBLE";
})(CVVPresenceCode || (exports.CVVPresenceCode = CVVPresenceCode = {}));
var MotoECICode;
(function (MotoECICode) {
    MotoECICode[MotoECICode["NON_AUTHENTICATED_SECURE_ECOMMERCE_TRANSACTION"] = 7] = "NON_AUTHENTICATED_SECURE_ECOMMERCE_TRANSACTION";
})(MotoECICode || (exports.MotoECICode = MotoECICode = {}));
var TerminalCapabilityCode;
(function (TerminalCapabilityCode) {
    TerminalCapabilityCode[TerminalCapabilityCode["KEY_ENTERED"] = 5] = "KEY_ENTERED";
})(TerminalCapabilityCode || (exports.TerminalCapabilityCode = TerminalCapabilityCode = {}));
var TerminalEnvironmentCode;
(function (TerminalEnvironmentCode) {
    TerminalEnvironmentCode[TerminalEnvironmentCode["ECOMMERCE"] = 6] = "ECOMMERCE";
})(TerminalEnvironmentCode || (exports.TerminalEnvironmentCode = TerminalEnvironmentCode = {}));
var TerminalType;
(function (TerminalType) {
    TerminalType[TerminalType["ECOMMERCE"] = 2] = "ECOMMERCE";
})(TerminalType || (exports.TerminalType = TerminalType = {}));
var TransactionSetupMethod;
(function (TransactionSetupMethod) {
    TransactionSetupMethod[TransactionSetupMethod["CREDIT_CARD_SALE"] = 1] = "CREDIT_CARD_SALE";
})(TransactionSetupMethod || (exports.TransactionSetupMethod = TransactionSetupMethod = {}));
var DeviceInputCode;
(function (DeviceInputCode) {
    DeviceInputCode[DeviceInputCode["NOT_USED"] = 0] = "NOT_USED";
    DeviceInputCode[DeviceInputCode["UNKNOWN"] = 1] = "UNKNOWN";
    DeviceInputCode[DeviceInputCode["TERMINAL"] = 2] = "TERMINAL";
    DeviceInputCode[DeviceInputCode["KEYBOARD"] = 3] = "KEYBOARD";
})(DeviceInputCode || (exports.DeviceInputCode = DeviceInputCode = {}));
var Device;
(function (Device) {
    Device[Device["DEFAULT"] = 0] = "DEFAULT";
    Device[Device["MAGTEK_ENCRYPTED_SWIPE"] = 1] = "MAGTEK_ENCRYPTED_SWIPE";
    Device[Device["ENCRYPTED_INPUT_DEVICE"] = 2] = "ENCRYPTED_INPUT_DEVICE";
})(Device || (exports.Device = Device = {}));
var ReversalType;
(function (ReversalType) {
    ReversalType[ReversalType["SYSTEM"] = 0] = "SYSTEM";
    ReversalType[ReversalType["FULL"] = 1] = "FULL";
    ReversalType[ReversalType["PARTIAL"] = 2] = "PARTIAL";
})(ReversalType || (exports.ReversalType = ReversalType = {}));
var TransactionStatusCode;
(function (TransactionStatusCode) {
    TransactionStatusCode[TransactionStatusCode["IN_PROCESS"] = 0] = "IN_PROCESS";
    TransactionStatusCode[TransactionStatusCode["APPROVED"] = 1] = "APPROVED";
    TransactionStatusCode[TransactionStatusCode["DECLINED"] = 2] = "DECLINED";
    TransactionStatusCode[TransactionStatusCode["DUPLICATE"] = 3] = "DUPLICATE";
    TransactionStatusCode[TransactionStatusCode["VOIDED"] = 4] = "VOIDED";
    TransactionStatusCode[TransactionStatusCode["AUTHORIZED"] = 5] = "AUTHORIZED";
    TransactionStatusCode[TransactionStatusCode["AUTH_COMPLETED"] = 6] = "AUTH_COMPLETED";
    TransactionStatusCode[TransactionStatusCode["REVERSED"] = 7] = "REVERSED";
    TransactionStatusCode[TransactionStatusCode["SUCCESS"] = 8] = "SUCCESS";
    TransactionStatusCode[TransactionStatusCode["RETURNED"] = 9] = "RETURNED";
    TransactionStatusCode[TransactionStatusCode["PENDING"] = 10] = "PENDING";
    TransactionStatusCode[TransactionStatusCode["QUEUED"] = 11] = "QUEUED";
    TransactionStatusCode[TransactionStatusCode["UNKNOWN"] = 12] = "UNKNOWN";
    TransactionStatusCode[TransactionStatusCode["ERROR"] = 13] = "ERROR";
    TransactionStatusCode[TransactionStatusCode["ORIGINATED"] = 14] = "ORIGINATED";
    TransactionStatusCode[TransactionStatusCode["SETTLED"] = 15] = "SETTLED";
    TransactionStatusCode[TransactionStatusCode["PARTIAL_APPROVED"] = 16] = "PARTIAL_APPROVED";
    TransactionStatusCode[TransactionStatusCode["REJECTED"] = 17] = "REJECTED";
    TransactionStatusCode[TransactionStatusCode["DCC_REQUESTED"] = 20] = "DCC_REQUESTED";
})(TransactionStatusCode || (exports.TransactionStatusCode = TransactionStatusCode = {}));
//# sourceMappingURL=enums.js.map